import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import SEO from "gatsby-theme-blank/src/components/seo"
import AdditionalInformation from "gatsby-theme-blank/src/components/additional-information"
import {
  pageActu,
  pageActuAdditionalInfos,
  actualite,
  actualiteImg,
  actualiteTags,
  actualiteTaxo,
  actualiteTitle,
  actualiteContentFooter,
  actualiteContentFooterBack,
  actualiteContentFooterRight,
  actualiteContentFooterDate,
  socialPanelContainer,
  editButton,
} from "./styles/detailsActu.module.scss"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import PropTypes from "prop-types"
import Ariane from "gatsby-theme-blank/src/components/Ariane/ariane"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import {
  ActuAdditionalInfos,
  ActualiteTags,
  ActuFooterBack,
  ActuFooterDate,
} from "./styled-components/actualite-styled"
import { coverSpeed } from "../../constants"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import FadeIn from "react-fade-in"
import SocialPanel from "gatsby-theme-blank/src/components/SocialMedias/social-panel"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"
import { LightBoxImage } from "gatsby-theme-blank/src/components/LightBoxImage/light-box-image"
//-----------------------Query Graphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodeActualites(path: { alias: { eq: $slug } }) {
      ...ActualiteItem
    }
  }
`

//-----------------------Query Graphql---------------------------//

//-----------------------Parent component---------------------------//

const ActualiteTemplate = ({ data, location }) => {
  const buildColors = useBuildData().theme_settings.palette
  const nodeActualites = data.nodeActualites
  const allTaxos = nodeActualites.relationships.field_taxonomie_thematique
    .map((taxo) => {
      return taxo.name
    })
    .join()
  return (
    <Layout>
      <SEO
        title={nodeActualites.title}
        description={
          "Dans cette page, vous découvrez l'actualité suivante : " +
          nodeActualites.title +
          ", mais aussi l'ensemble des thématiques suivantes : " +
          allTaxos
        }
        nodeImageUrl={
          nodeActualites.relationships?.field_image_actus?.localFile
            ?.SlugifiedPublicUrl
        }
      />
      <FadeIn delay={250}>
        <Ariane
          pageNameLink="/actualites"
          pageName="Toutes les actualités"
          isDetail={true}
          postName={nodeActualites.title}
        />
        <section className={pageActu}>
          <ActualiteContent colors={buildColors} actu={nodeActualites} />
          <ActualiteContentFooter
            location={location.href}
            actu={nodeActualites}
          />
        </section>
        <ActualiteInfos actu={nodeActualites} />
      </FadeIn>
    </Layout>
  )
}
//-----------------------Parent component---------------------------//

//-----------------------Child component/Content---------------------------//

const ActualiteContent = ({ actu, colors }) => {
  return (
    <article className={actualite}>
      <div className={actualiteImg}>
        <EditButton
          link={"/node/" + actu.drupal_internal__nid + "/edit"}
          addedClass={editButton}
        />
        {actu.relationships?.field_image_actus?.localFile && (
          <LightBoxImage
            type={"node"}
            node={{
              alt: actu.field_image_actus.alt,
              file: actu.relationships.field_image_actus.localFile,
            }}
          />
        )}
      </div>
      {actu.relationships.field_taxonomie_thematique && (
        <ActualiteTags className={actualiteTags} role={"list"}>
          {actu.relationships.field_taxonomie_thematique.map((taxo) => (
            <span key={taxo.name} className={actualiteTaxo} role={"listitem"}>
              <AniLink
                cover
                direction="down"
                bg={colors.b_color_gradients.b_dark}
                duration={coverSpeed}
                to={taxo.path.alias}
              >
                {taxo.name}
              </AniLink>
            </span>
          ))}
        </ActualiteTags>
      )}
      <h1 className={actualiteTitle}>{actu.title}</h1>
      {actu.body && <ContentTransformer content={actu.body.processed} />}
    </article>
  )
}
//-----------------------Child component/Content---------------------------//

//-----------------------Child component/Content Footer---------------------------//

const ActualiteContentFooter = ({ actu, location }) => (
  <>
    <div className={actualiteContentFooter}>
      <ActuFooterBack className={actualiteContentFooterBack}>
        <TransitionFade
          arialabel="Retour à la liste des actualités"
          link="/actualites"
        >
          Retour à la liste des actualités
        </TransitionFade>
      </ActuFooterBack>
      <div className={actualiteContentFooterRight}>
        <ActuFooterDate className={actualiteContentFooterDate}>
          {actu.field_date_de_publication || actu.created}
        </ActuFooterDate>
      </div>
    </div>
    <div className={socialPanelContainer}>
      <SocialPanel location={location} postData={actu} />
    </div>
  </>
)
//-----------------------Child component/Content Footer---------------------------//

//-----------------------Child component/Infos---------------------------//
const ActualiteInfos = ({ actu }) => (
  <>
    {actu.field_infos_complementaires && (
      <ActuAdditionalInfos className={pageActuAdditionalInfos}>
        <AdditionalInformation node={actu} />
      </ActuAdditionalInfos>
    )}
  </>
)
//-----------------------Child component/Infos---------------------------//

//-----------------------Prop-Types---------------------------//
ActualiteTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object,
}
ActualiteContent.propTypes = {
  actu: PropTypes.object.isRequired,
  colors: PropTypes.object,
}
ActualiteInfos.propTypes = {
  actu: PropTypes.object.isRequired,
}
ActualiteContentFooter.propTypes = {
  actu: PropTypes.object.isRequired,
  location: PropTypes.object,
}
//-----------------------Prop-Types---------------------------//

export default ActualiteTemplate
